import React, { FC } from "react";

import { DoubleMateriality } from "@components/main/csrd";

const CsrdDashboardPage: FC = () => <DoubleMateriality />;

export default CsrdDashboardPage;
